const SESSION_CHECK_KEY = 'lastPlatformSessionCheck';
const SESSION_VALIDITY_MS = 20 * 60 * 1000; // 20 minutes

const shouldCheckSession = () => {
  const lastCheck = localStorage.getItem(SESSION_CHECK_KEY);
  const now = Date.now();

  if (!lastCheck || now - parseInt(lastCheck, 10) > SESSION_VALIDITY_MS) {
    return true;
  }

  return false;
};

const updateLastSessionCheckTimestamp = () => {
  localStorage.setItem(SESSION_CHECK_KEY, Date.now().toString());
};

export const clearLastSessionCheckTimestamp = () => {
  localStorage.removeItem(SESSION_CHECK_KEY);
};

/**
 * Checks if the session should be validated based on the last check timestamp.
 * If the last check was more than SESSION_VALIDITY_MS milliseconds ago,
 * it returns true, indicating that the session should be checked again.
 * Otherwise, it returns false.
 *
 * @param {Object} store - The Vuex store instance.
 * @param {boolean} fromInApp - Indicates if the check is triggered from outside the app.
 * @returns {boolean} - True if the session should be checked, false otherwise.
 */
export const checkSessionAndUpdateIfValid = async (store, fromInApp = true) => {
  if (!shouldCheckSession() && fromInApp) return true;

  const result = await store.dispatch('currentUser/checkPlatformSession');
  if (result === true) {
    updateLastSessionCheckTimestamp();
  }
  return result;
};
